<template>
  <div class="container-fluid" style="padding:0;">
    <tab></tab>
    <div class="row">
      <div class="activity-top" :class="{'hidden-xs hidden-sm':isShowWeb}">
        <img :src="`${pageUrl.imgUrl}${pageInfo.pic}`" alt="#" class="inner-item-img"/>
        <div class="activity-top-font">
          <div class="top-font-font">{{lanType==1?pageInfo.title:pageInfo.titleEn}}</div>
        </div>
      </div>

      <div class="phone-activity-top hidden-md hidden-lg" v-if="isShowWeb">
        <img :src="`${pageUrl.imgUrl}${pageInfo.pic}`" alt="#" class="phone-inner-img"/>
        <div class="activity-top-font">
          <div class="phone-font-font">{{lanType==1?pageInfo.title:pageInfo.titleEn}}</div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="dynamic-top middle" :class="{'hidden-xs hidden-sm':isShowWeb}">
        <div class="dynamic-top-list color1 border1" :class="{'choiceBg1':type==1}" @click="choiceType(1)">{{lanType==1?'即将开始':'Begin in a minute'}}</div>
        <div class="dynamic-top-list color1 border1" :class="{'choiceBg1':type==2}" @click="choiceType(2)">{{lanType==1?'以往活动':'Past events'}}</div>
      </div>

      <div class="dynamic-top hidden-md hidden-lg middle spaceBetween wrap" v-if="isShowWeb">
        <div class="phone-dynamic-top middle color1 border1" :class="{'choiceBg1':type==1}" @click="choiceType(1)">{{lanType==1?'即将开始':'Begin in a minute'}}</div>
        <div class="phone-dynamic-top middle color1 border1" :class="{'choiceBg1':type==2}" @click="choiceType(2)">{{lanType==1?'以往活动':'Past events'}}</div>
      </div>
    </div>

    <div class="row">
      <div :class="{'hidden-xs hidden-sm':isShowWeb}">
        <div class="web-index-foot">
          <!-- <div class="index-foot-tips">2020年11月</div> -->
          <div class="index-foot-list spaceBetween" v-for="(item,index) in campaignList" :key="index" @click="goActivityDetail(item)">
            <div class="foot-list-left start">
              <div class="columnBetween" style="align-items: center;">
                <div class="list-left-tips">{{lanType==1?item.addressStr:item.addressStrEn}}</div>
                <div class="list-left-radiu border1 columnCenter">
                  <div class="left-radiu-tips color1">{{lanType==1?item.startTimeMoth:item.startTimeMothEn}}</div>
                  <div class="left-radiu-center color1">{{lanType==1?item.startTimeDay:item.startTimeDayEn}}</div>
                </div>
              </div>
              
              <div class="list-left-right">
                <div class="left-right-title">{{lanType==1?item.title:item.titleEn}}</div>
                <div class="left-right-bottom start">
                  <div class="right-bottom-list start">
                    <img src="@/images/icon1.png" alt="#" class="bottom-list-img"/>
                    <div class="bottom-list-font" v-if="item.address">{{lanType==1?item.address:item.addressEn}}</div>
                    <div class="bottom-list-font" v-else>{{lanType==1?'线上会议':'Online conference'}}</div>
                  </div>
                  <div class="right-bottom-list start">
                    <img src="@/images/icon2.png" alt="#" class="bottom-list-img"/>
                    <div class="bottom-list-font">{{item.start_time}} —— {{item.end_time}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="foot-list-right">{{lanType==1?'查看详情':'View details'}}</div>
          </div>

          <div class="" v-if="campaignList.length==0">{{lanType==1?'暂无活动信息':'No activity information'}}</div>
          <!-- <div class="index-foot-list spaceBetween">
            <div class="foot-list-left start">
              <div class="list-left-tips">SBTi</div>
              <div class="list-left-radiu border1 columnCenter">
                <div class="left-radiu-tips color1">11月</div>
                <div class="left-radiu-center color1">20日</div>
              </div>
              <div class="list-left-right">
                <div class="left-right-title">活动名称活动活动名称活动活动名称活动活动名称活动名称活动活动名称</div>
                <div class="left-right-bottom start">
                  <div class="right-bottom-list start">
                    <img src="@/images/icon1.png" alt="#" class="bottom-list-img"/>
                    <div class="bottom-list-font">线上会议</div>
                  </div>
                  <div class="right-bottom-list start">
                    <img src="@/images/icon2.png" alt="#" class="bottom-list-img"/>
                    <div class="bottom-list-font">20：00 —— 21：00</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="foot-list-right">查看详情</div>
          </div> -->
        </div>

        <div class="dynamic-paging middle" v-if="totalList&&totalList.length>0&&campaignList&&campaignList.length>0">
          <div class="dynamic-paging-btn dynamic-paging-up middle" @click="upPage">{{lanType==1?'上一页':'UP'}}</div>
          <ul class="middle"  v-for="(item,index) in totalList" :key="index" v-if="totalIndex==index">
            <li class="dynamic-paging-list middle" :class="{'bg1':page==res}" v-for="(res,index) in item" :key="index" @click="choicePage(index+1)">{{res}}</li>
            
          </ul>
          <div class="dynamic-paging-btn dynamic-paging-down middle" @click="downPage">{{lanType==1?'下一页':'DOWN'}}</div>
        </div>

        <!-- <div class="web-index-foot">
          <div class="index-foot-tips">2020年11月</div>
          <div class="index-foot-list spaceBetween">
            <div class="foot-list-left start">
              <div class="list-left-tips">SBTi</div>
              <div class="list-left-radiu border1 columnCenter">
                <div class="left-radiu-tips color1">11月</div>
                <div class="left-radiu-center color1">20日</div>
              </div>
              <div class="list-left-right">
                <div class="left-right-title">活动名称活动活动名称活动活动名称活动活动名称活动名称活动活动名称</div>
                <div class="left-right-bottom start">
                  <div class="right-bottom-list start">
                    <img src="@/images/icon1.png" alt="#" class="bottom-list-img"/>
                    <div class="bottom-list-font">线上会议</div>
                  </div>
                  <div class="right-bottom-list start">
                    <img src="@/images/icon2.png" alt="#" class="bottom-list-img"/>
                    <div class="bottom-list-font">20：00 —— 21：00</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="foot-list-right">查看详情</div>
          </div>
          <div class="index-foot-list spaceBetween">
            <div class="foot-list-left start">
              <div class="list-left-tips">SBTi</div>
              <div class="list-left-radiu border1 columnCenter">
                <div class="left-radiu-tips color1">11月</div>
                <div class="left-radiu-center color1">20日</div>
              </div>
              <div class="list-left-right">
                <div class="left-right-title">活动名称活动活动名称活动活动名称活动活动名称活动名称活动活动名称</div>
                <div class="left-right-bottom start">
                  <div class="right-bottom-list start">
                    <img src="@/images/icon1.png" alt="#" class="bottom-list-img"/>
                    <div class="bottom-list-font">线上会议</div>
                  </div>
                  <div class="right-bottom-list start">
                    <img src="@/images/icon2.png" alt="#" class="bottom-list-img"/>
                    <div class="bottom-list-font">20：00 —— 21：00</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="foot-list-right">查看详情</div>
          </div>
        </div> -->
      </div>

      <div class="hidden-md hidden-lg" v-if="isShowWeb">

        <div class="phone-index-foot">
          <!-- <div class="phone-foot-tips">2020年11月</div> -->
          <div class="phone-foot-list spaceBetween wrap">
            <div class="phone-list-left start" v-for="(item,index) in campaignList" :key="index" @click="goActivityDetail(item)"> 
              <div class="columnBetween" style="align-items: center;padding-left: 0.2rem;">
                <div class="phone-left-tips">{{lanType==1?item.addressStr:item.addressStrEn}}</div>
                <div class="phone-left-radiu border1 columnCenter">
                  <div class="phone-radiu-tips color1">{{lanType==1?item.startTimeMoth:item.startTimeMothEn}}</div>
                  <div class="phone-radiu-center color1">{{lanType==1?item.startTimeDay:item.startTimeDayEn}}</div>
                </div>
              </div>
              
              <div class="phone-left-right">
                <div class="phone-right-title">{{lanType==1?item.title:item.titleEn}}</div>
                <div class="phone-right-bottom start">
                  <div class="phone-bottom-list start">
                    <img src="@/images/icon1.png" alt="#" class="phone-list-img"/>
                    <div class="phone-list-font fontHidden" style="width: 1.6rem;" v-if="item.address">{{lanType==1?item.address:item.addressEn}}</div>
                    <div class="phone-list-font" v-else>{{lanType==1?'线上会议':'Online conference'}}</div>
                  </div>
                  <div class="phone-bottom-list start" style="margin-right:0;">
                    <img src="@/images/icon2.png" alt="#" class="phone-list-img"/>
                    <div class="phone-list-font">{{item.start_time}} —— {{item.end_time}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="phone-foot-list spaceBetween">
            <div class="phone-list-left start">
              <div class="phone-left-tips">SBTi</div>
              <div class="phone-left-radiu border1 columnCenter">
                <div class="phone-radiu-tips color1">11月</div>
                <div class="phone-radiu-center color1">20日</div>
              </div>
              <div class="phone-left-right">
                <div class="phone-right-title">活动名称活动活动名称活动活动名称活动活动名称活动名称活动活动名称</div>
                <div class="phone-right-bottom start">
                  <div class="phone-bottom-list start">
                    <img src="@/images/icon1.png" alt="#" class="phone-list-img"/>
                    <div class="phone-list-font">线上会议</div>
                  </div>
                  <div class="phone-bottom-list start" style="margin-right:0;">
                    <img src="@/images/icon2.png" alt="#" class="phone-list-img"/>
                    <div class="phone-list-font">20：00 —— 21：00</div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>

        <div class="phone-legs-btn middle" @click="moreBtn" v-if="total > 9">{{lanType==1?'加载更多':'Load more'}}</div>
        <!-- <div class="phone-index-foot">
          <div class="phone-foot-tips">2020年11月</div>
          <div class="phone-foot-list spaceBetween">
            <div class="phone-list-left start">
              <div class="phone-left-tips">SBTi</div>
              <div class="phone-left-radiu border1 columnCenter">
                <div class="phone-radiu-tips color1">11月</div>
                <div class="phone-radiu-center color1">20日</div>
              </div>
              <div class="phone-left-right">
                <div class="phone-right-title">活动名称活动活动名称活动活动名称活动活动名称活动名称活动活动名称</div>
                <div class="phone-right-bottom start">
                  <div class="phone-bottom-list start">
                    <img src="@/images/icon1.png" alt="#" class="phone-list-img"/>
                    <div class="phone-list-font">线上会议</div>
                  </div>
                  <div class="phone-bottom-list start" style="margin-right:0;">
                    <img src="@/images/icon2.png" alt="#" class="phone-list-img"/>
                    <div class="phone-list-font">20：00 —— 21：00</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="phone-foot-list spaceBetween">
            <div class="phone-list-left start">
              <div class="phone-left-tips">SBTi</div>
              <div class="phone-left-radiu border1 columnCenter">
                <div class="phone-radiu-tips color1">11月</div>
                <div class="phone-radiu-center color1">20日</div>
              </div>
              <div class="phone-left-right">
                <div class="phone-right-title">活动名称活动活动名称活动活动名称活动活动名称活动名称活动活动名称</div>
                <div class="phone-right-bottom start">
                  <div class="phone-bottom-list start">
                    <img src="@/images/icon1.png" alt="#" class="phone-list-img"/>
                    <div class="phone-list-font">线上会议</div>
                  </div>
                  <div class="phone-bottom-list start" style="margin-right:0;">
                    <img src="@/images/icon2.png" alt="#" class="phone-list-img"/>
                    <div class="phone-list-font">20：00 —— 21：00</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>

    <footerBar ref="footerView"></footerBar>
  </div>
</template>

<script>
import tab from '@/components/tab'
import footerBar from '@/components/footerBar'
import axios from 'axios'
import { chunkArr,format } from '@/utils/util'
import config from '@/utils/config';
export default {
  name: 'activity',
  components: {
    tab:tab,
    footerBar:footerBar
  },
  data () {
    return {
      type:1,
      page:1,
      per_page:9,
      total:0,
      totalIndex:0,
      current_page:0,
      totalFor:[],
      totalList:[],
      campaignList:[],
      isShowWeb:config.urlList.isShowWeb,
      lanType:1,
      pageUrl: config.urlList,
      pageInfo: {}
    }
  },
  methods:{
    fatherMethod(type){
      const vm=this
      vm.lanType=type
      setTimeout(()=>{
        vm.$refs.footerView.choiceType(type);
      },400)
    },
    choiceType(num){
      const vm=this;
      vm.type=num;
      vm.queryCampaignList();
    },
    queryCampaignList(){
      const vm=this
      let arr = []
      axios.post(`${config.urlList.queryUrl}/api/cbh/campaign_list`,{
        state:vm.type,
        is_recommend:0,
        per_page:9,
        page:vm.page,
        per_page:vm.per_page
      }).then(res => {
        if(res.data.code==1){
          res.data.data.data.forEach(da=>{
            
            da.titleEn = da.titleEn?da.titleEn:da.title
            da.addressEn = da.addressEn?da.addressEn:da.address
            da.picStr=`${config.urlList.imgUrl}${da.pic}`;
            da.addressStr=format(new Date(da.start_date),' YYYY年');
            da.addressStrEn=format(new Date(da.start_date),' YYYY/');
            da.startTimeMoth=format(new Date(da.start_date),' MM月')
            da.startTimeMothEn=format(new Date(da.start_date),' MM/')
            da.startTimeDay=format(new Date(da.start_date),' DD日')
            da.startTimeDayEn=format(new Date(da.start_date),' DD')
          })
          vm.campaignList=res.data.data.data;
          vm.current_page=res.data.data.last_page;
          vm.total=res.data.data.last_page;
          //vm.total=100
          //chunkArr
          for(var i=0;i<vm.total;i++){
            arr.push(i+1);
          }
          vm.totalList=chunkArr(arr,10)
          vm.totalFor=vm.totalList[vm.totalIndex]
        }
      })
    },
    choicePage(num){
      const vm=this
      vm.page=num;
      vm.queryCampaign();
    },
    upPage(){
      const vm=this;
      if(vm.totalIndex>0){
        vm.totalIndex--
      }
    },
    downPage(){
      const vm=this;
      if(vm.totalIndex<vm.totalList.length-1){
        vm.totalIndex++
      }
      //vm.queryCampaign();
    },
    moreBtn(){
      const vm=this
      if(vm.total>vm.per_page){
        vm.per_page+=9;
        vm.queryCampaign()
      }
    },
    goActivityDetail(item){
      const vm=this
      vm.$router.push({ path:'/activityDetail',query:{id:item.id}})
    },
    queryPageInfo(){
      const vm=this;
      axios.get(
      `${config.urlList.queryUrl}/api/cbh/page/3`,
      ).then(res => {
        if(res.data.code==1){
          vm.pageInfo = res.data.data;
        }
      })
    },
  },
  created () {
    const vm = this;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
  mounted(){
    const vm=this
    vm.queryCampaignList()
    vm.queryPageInfo()
  }
}
</script>
<style scoped>
/**  pc banner图  **/
.activity-top{
  width: 100%;
  height: 4.0625rem;
  position: relative;
}
.inner-item-img{
  width: 100%;
  height: 100%;
}
.activity-top-font{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.top-font-font{
  font-size: 0.45rem;
  color: #fff;
  font-family: 'wwf';
}
/**  web Banner图  **/
.phone-activity-top{
  width: 100%;
  height: 8rem;
  position: relative;
}
.phone-inner-img{
  width: 100%;
  height: 100%;
}
.phone-font-font{
  font-size: 0.8rem;
  color: #fff;
}

/**  pc  **/
.dynamic-top{
  padding: 0.5rem;
  height: auto;
}
.dynamic-top-list{
  width: 1.1875rem;
  height: 0.325rem;
  text-align: center;
  line-height: 0.325rem;
  margin-right: 0.2rem;
  cursor: pointer;
  border-radius: 6px;
}

/**  web  **/
.phone-dynamic-top{
  width: 3.4rem;
  height: 0.8rem;
  font-size: 0.32rem;
  text-align: center;
  line-height: 0.8rem;
  margin-right: 0.2rem;
  margin-bottom: 0.2rem;
}

/**  pc活动预告  **/
.web-index-foot{
  padding: 0.3375rem 0.5rem 0;
  height: auto;
}
.index-foot-tips{
  margin-bottom: 0.1875rem;
  font-size: 0.225rem;
  color: #999999;
  text-align: left;
  font-weight: 'wwf';
}
.index-foot-list{
  width: 100%;
  padding: 0.15rem 0;
  height: auto;
  box-shadow: 2px 2px 4px #c9c9c9;
  margin-bottom: 0.225rem;
  cursor: pointer;
}
.foot-list-left{
  width: auto;
  height: auto;
  padding: 0 0.1rem;
}
.list-left-tips{
  padding: 0 0.25rem;
  height: auto;
  background: #32a5cf;
  font-size: 0.15rem;
  color: #fff;
  text-align: center;
  line-height: 1.5;
}
.list-left-radiu{
  width: 0.625rem;
  height: 0.625rem;
  border-radius: 50%;
  border-width: 2px !important;
  margin-top: 0.08rem;
}
.left-radiu-tips{
  font-size: 0.15rem;
  color: #32a5cf;
  font-weight: 'wwf';
  line-height: 1.4;
}
.left-radiu-center{
  font-size: 0.225rem;
  color: #32a5cf;
  font-family: 'wwf';
  line-height: 1.4;
}
.list-left-right{
  margin-left: 0.2625rem;
  height: 0.75rem;
  text-align: left;
}
.left-right-title{
  font-size: 0.1875rem;
  color: #000;
  font-family: 'wwf';
  line-height: 1;
  margin-top: 0.1625rem;
}
.left-right-bottom{
  margin-top: 0.1125rem;
}
.bottom-list-img{
  width: 0.1875rem;
  height: auto;
  margin-right: 0.0625rem;
}
.right-bottom-list{
  margin-right: 0.25rem;
}
.bottom-list-font{
  font-size: 0.1125rem;
  color: #000;
  line-height: 0.1875rem;
}
.foot-list-right{
  color: #49bc9b;
  font-size: 0.1125rem;
  margin-right: 0.175rem;
}

/**  web活动预告  **/
.phone-index-foot{
  padding: 0.373rem 0.5rem 0;
  height: auto;
}
.phone-foot-tips{
  margin-bottom: 0.48rem;
  font-size: 0.64rem;
  color: #999999;
  text-align: left;
  font-weight: 'wwf';
}
.phone-foot-list{
  width: 100%;
  height: auto;
  margin-bottom: 0.533rem;
}
.phone-list-left{
  width: 100%;
  height: auto;
  margin-bottom: 0.533rem;
  box-shadow: 2px 2px 4px #c9c9c9;
}
.phone-left-tips{
  width: 2.1rem;
  height: auto;
  background: #32a5cf;
  font-size: 0.4rem;
  line-height: 1.5;
  color: #fff;
  text-align: center;
}
.phone-left-radiu{
  width: 1.333rem;
  min-width: 1.333rem;
  height: 1.333rem;
  border-radius: 50%;
  border-width: 2px !important;
  margin-top: 0.2rem;
}
.phone-radiu-tips{
  font-size: 0.32rem;
  color: #32a5cf;
  font-weight: 'wwf';
  line-height: 1.4;
}
.phone-radiu-center{
  font-size: 0.48rem;
  color: #32a5cf;
  font-family: 'wwf';
  line-height: 1.4;
}
.phone-left-right{
  margin-left: 0.273rem;
  height: 2.4rem;
  padding-right: 6px;
}
.phone-right-title{
  font-size: 0.4rem;
  color: #000;
  font-family: 'wwf';
  line-height: 1.4;
  margin-top: 0.2667rem;
  text-align: left;
}
.phone-right-bottom{
  margin-top: 0.32rem;
}
.phone-list-img{
  width: 0.426rem;
  height: auto;
  margin-right: 0.133rem;
}
.phone-bottom-list{
  margin-right: 0.8rem;
}
.phone-list-font{
  font-size: 0.32rem;
  color: #000;
  line-height: 0.426rem;
}

/*  pc  */
.dynamic-paging{
  margin-top: 0.325rem;
  padding: 0 0.5rem;
}
.dynamic-paging-btn{
  width: 1.25rem;
  height: 0.375rem;
  background: #eeeeee;
  font-size: 0.15rem;
  color: #49bc9b;
  font-weight: 600;
  margin: 0 0.125rem;
  cursor: pointer;
}
.dynamic-paging-list{
  width: 0.375rem;
  height: 0.375rem;
  background: #eeeeee;
  font-size: 0.15rem;
  color: #49bc9b;
  font-weight: 600;
  margin: 0 0.125rem;
  margin-bottom: 0;
  cursor: pointer;
}
.bg1{
  background: #49bc9b;
  color: #fff;
}

/**  web  **/
.phone-legs-btn{
  width: 4rem;
  height: 1.067rem;
  background: #49bc9b;
  font-size: 0.4rem;
  color: #fff;
  margin: 0 auto 0.5rem;
}


.color1{
  color: #32a5cf;
}
.border1{
  border:1px solid #32a5cf;
}
.choiceBg1{
  background: #32a5cf;
  color: #fff;
}
</style>

